/* eslint-disable tss-unused-classes/unused-classes */
import { Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPreExtensionModalProps } from '../PlacementDetails/Edit/store/placementPageAttributes.selector';
import { ExtensionOverrideButtons } from './ExtensionOverrideButtons';
import uuid from 'react-uuid';
import moment from 'moment';
import { pageAttributesActions } from '../PlacementDetails/Edit/store/placementPageAttributes.redux';
import { missingField } from 'app/constants';
import { selectPlacementStatus } from 'store/redux-store/placement-status/selectors';

const useStyles = makeStyles()(theme => ({
  placementStatusChangeDDIcon: {
    color: 'white !important',
  },
  placementStatusMenuItem: {
    textTransform: 'uppercase',
    fontSize: '12px',
  },
  placementStatusInput: {
    textTransform: 'uppercase',
    fontSize: '12px',
  },
  dialogContainer: {
    width: '500px',
    maxWidth: '500px',
  },
  dropdownStyle: {
    marginTop: '42px',
  },
  root: {
    color: 'white',
  },
  rootDisabled: {
    '&:hover': {
      cursor: 'not-allowed',
    },
  },
}));

export const PreExtensionModal = () => {
  const { 
    open, 
    title,  
    extensionStatusId, 
    extensionStatus 
  } = useSelector(selectPreExtensionModalProps);
  const { extensionDetails: { endDateTravelerOption } } = useSelector(selectPlacementStatus);
  const { classes } = useStyles();
  const dispatch = useDispatch();

  const [formBtnAccessorId] = useState(uuid());
  const submitExtensionForm = () => document.getElementById(formBtnAccessorId)?.click();
  const onClose = () => {
    dispatch(
      pageAttributesActions.setPreExtensionModalProps({
        open: false,
      }),
    );
  };

  const statement = React.useMemo(() => {
    const dateMoment = moment(endDateTravelerOption?.endDate);
    return (
      <Typography variant="body1">
            {
              `An End Date modification in "${endDateTravelerOption?.approvalStatus}"
              status exists for this Placement. End Date =
              ${
                dateMoment.isValid()
                ? moment(endDateTravelerOption?.endDate).format('MM/DD/YYYY')
                : missingField
              }`
            }
      </Typography>
    );
  }, [endDateTravelerOption?.approvalStatus, endDateTravelerOption?.endDate]);

  return (
    <GenericDialog
      variant="white"
      fullWidth
      classes={{
        paper: classes.dialogContainer,
      }}
      open={open}
      onClose={onClose}
      draggable
      dialogTitleProps={{
        text: title,
      }}
      dialogActions={[
        {
          onClick: onClose,
          text: 'Cancel',
          variant: 'text',
          color: 'tertiary',
          useDialogOnCloseEvent: true,
        },
        {
          text: 'Continue',
          variant: 'contained',
          onClick: submitExtensionForm,
          type: 'submit',
        },
      ]}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {statement}
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">{`Please select how you would like to proceed:`}</Typography>
        </Grid>
        <ExtensionOverrideButtons
          endDateTravelerOption={endDateTravelerOption}
          formBtnAccessorId={formBtnAccessorId}
          extensionStatusId={extensionStatusId}
          extensionStatus={extensionStatus}
        />
      </Grid>
    </GenericDialog>
  );
};
